module.exports = __webpack_public_path__ + "img/card-btn-1.ffba60e9.png";